import _implicitStylesheets from "./headerV2.css";
import _implicitScopedStylesheets from "./headerV2.scoped.css?scoped=true";
import _aceNotifications from "ace/notifications";
import _searchTypeAhead from "search/typeAhead";
import _aceHelpCenter from "ace/helpCenter";
import _aceAppLauncher from "ace/appLauncher";
import _wdsSpinner from "wds/spinner";
import _aceOrgContextMenu from "ace/orgContextMenu";
import _aceFavorites from "ace/favorites";
import _aceUserMenu from "ace/userMenu";
import _wdsButton from "wds/button";
import _axIcon from "ax/icon";
import _axBadge from "ax/badge";
import _aceUserMenuMobile from "ace/userMenuMobile";
import _aceHelpCenterMobile from "ace/helpCenterMobile";
import _axUnifiedHeaderV2 from "ax/unifiedHeaderV2";
import {freezeTemplate, parseFragment, registerTemplate, sanitizeAttribute} from "lwc";
const $fragment1 = parseFragment`<svg class="brand-logo${0}" width="45" height="32" viewBox="0 0 45 32" aria-hidden="true" focusable="false"${2}><use${"a1:href"}${3}/></svg>`;
const $fragment2 = parseFragment`<span class="brand-text${0}"${2}>${"t1"}</span>`;
const $fragment3 = parseFragment`<img class="header-search-icon${0}" src="/assets/images/ai-search.svg" alt="" aria-hidden="true"${2}>`;
const $fragment4 = parseFragment`<span class="visually-hidden${0}"${2}>${"t1"}</span>`;
const $fragment5 = parseFragment`<span class="visually-hidden${0}"${2}>${"t1"}</span>`;
const $fragment6 = parseFragment`<span class="org-card-name${0}"${"a0:title"}${2}>${"t1"}</span>`;
const $fragment7 = parseFragment`<span class="org-card-email${0}"${"a0:title"}${2}>${"t1"}</span>`;
const $fragment8 = parseFragment`<span class="org-card-domain${0}"${"a0:title"}${2}>${"t1"}</span>`;
const $fragment9 = parseFragment`<button class="org-card__switch-link${0}" data-testid="switch-org"${2}>${"t1"}</button>`;
const $fragment10 = parseFragment`<button class="org-card__switch-link org-picker-mobile-select${0}" data-testid="select-org"${2}>${"t1"}</button>`;
const stc0 = {
  key: 0
};
const stc1 = {
  "brand": true
};
const stc2 = {
  slotAssignment: "search",
  classMap: {
    "header-search-container": true
  },
  key: 7
};
const stc3 = {
  classMap: {
    "header-search": true
  },
  key: 10
};
const stc4 = {
  slotAssignment: "utility",
  classMap: {
    "header-utility": true
  },
  key: 11
};
const stc5 = {
  "utility-item": true
};
const stc6 = {
  classMap: {
    "utility-item": true
  },
  key: 14
};
const stc7 = {
  classMap: {
    "account-loading": true
  },
  attrs: {
    "role": "status",
    "aria-busy": "true"
  },
  key: 16
};
const stc8 = {
  props: {
    "ariaHidden": "true"
  },
  key: 19
};
const stc9 = {
  classMap: {
    "utility-item": true
  },
  key: 21
};
const stc10 = {
  classMap: {
    "utility-item": true
  },
  key: 22
};
const stc11 = {
  classMap: {
    "utility-item": true
  },
  key: 23
};
const stc12 = {
  "data-testid": "signup"
};
const stc13 = {
  "data-testid": "login"
};
const stc14 = {
  slotAssignment: "utilityMobile",
  classMap: {
    "account-loading": true
  },
  attrs: {
    "role": "status",
    "aria-busy": "true"
  },
  key: 27
};
const stc15 = {
  props: {
    "ariaHidden": "true"
  },
  key: 30
};
const stc16 = {
  slotAssignment: "utilityMobile",
  classMap: {
    "header-utility-mobile": true
  },
  key: 31
};
const stc17 = {
  classMap: {
    "org-card": true
  },
  key: 33
};
const stc18 = {
  classMap: {
    "org-card-header": true
  },
  key: 34
};
const stc19 = {
  "org-card-cloud": true
};
const stc20 = {
  classMap: {
    "org-card-meta": true
  },
  key: 43
};
const stc21 = {
  "org-card__edition": true
};
const stc22 = {
  slotAssignment: "utilityMobileDetail",
  classMap: {
    "header-utility-mobile": true
  },
  key: 50
};
const stc23 = {
  props: {
    "hideTitle": true
  },
  key: 52
};
const stc24 = {
  props: {
    "hideTitle": true
  },
  key: 54
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, ncls: api_normalize_class_name, b: api_bind, sp: api_static_part, st: api_static_fragment, d: api_dynamic_text, h: api_element, fr: api_fragment} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6, _m7, _m8, _m9} = $ctx;
  return [api_custom_element("ace-notifications", _aceNotifications, stc0), api_custom_element("ax-unified-header-v2", _axUnifiedHeaderV2, {
    className: api_normalize_class_name($cmp.unifiedHeaderClass),
    props: {
      "navItems": $cmp.navItems,
      "l2Content": $cmp.l2Content,
      "collections": $cmp.collections,
      "activeItemId": $cmp.activeItemId,
      "mobileUtilityDetails": $cmp.mobileUtilityDetails,
      "mobileUtilityItems": $cmp.mobileUtilityItems,
      "navigationAriaLabel": $cmp.labels.mainNavigationAriaLabel,
      "openNavigationAriaLabel": $cmp.labels.unifiedHeaderV2.openNavigationAriaLabel,
      "closeNavigationAriaLabel": $cmp.labels.unifiedHeaderV2.closeNavigationAriaLabel,
      "submenuAriaLabel": $cmp.labels.unifiedHeaderV2.submenuAriaLabel,
      "mobileBackLabel": $cmp.labels.unifiedHeaderV2.mobileBackLabel,
      "emptyNavigationLabel": $cmp.labels.unifiedHeaderV2.emptyNavigationLabel
    },
    key: 1,
    on: {
      "navclick": _m0 || ($ctx._m0 = api_bind($cmp.handleNavClick)),
      "navigate": _m1 || ($ctx._m1 = api_bind($cmp.handleL2Navigate)),
      "mobileutilitydetailchange": _m2 || ($ctx._m2 = api_bind($cmp.handleMobileUtilityDetailChange)),
      "mobileutilitynavigate": _m3 || ($ctx._m3 = api_bind($cmp.handleMobileUtilityNavigate))
    }
  }, [api_element("a", {
    slotAssignment: "brand",
    classMap: stc1,
    attrs: {
      "href": $cmp.homeUrl,
      "aria-label": $cmp.labels.brandText
    },
    key: 2
  }, [api_static_fragment($fragment1, 4, [api_static_part(1, {
    attrs: {
      "href": sanitizeAttribute("use", "http://www.w3.org/2000/svg", "href", "/images/icons.svg#salesforce-brand")
    }
  }, null)]), api_static_fragment($fragment2, 6, [api_static_part(1, null, api_dynamic_text($cmp.labels.brandText))])]), api_element("div", stc2, [api_static_fragment($fragment3, 9), api_custom_element("search-type-ahead", _searchTypeAhead, stc3)]), api_element("div", stc4, [api_custom_element("ace-help-center", _aceHelpCenter, {
    classMap: stc5,
    props: {
      "isLoggedIn": $cmp.isLoggedIn
    },
    key: 12
  }), $cmp.isLoggedIn ? api_fragment(13, [api_custom_element("ace-app-launcher", _aceAppLauncher, stc6)], 0) : null, $cmp.showAccountLoading ? api_fragment(15, [api_element("div", stc7, [api_static_fragment($fragment4, 18, [api_static_part(1, null, api_dynamic_text($cmp.labels.accountLoading))]), api_custom_element("wds-spinner", _wdsSpinner, stc8)])], 0) : $cmp.isLoggedIn ? api_fragment(15, [$cmp.showOrgContextMenu ? api_fragment(20, [api_custom_element("ace-org-context-menu", _aceOrgContextMenu, stc9)], 0) : api_fragment(20, [api_custom_element("ace-favorites", _aceFavorites, stc10), api_custom_element("ace-user-menu", _aceUserMenu, stc11)], 0)], 0) : api_fragment(15, [api_custom_element("wds-button", _wdsButton, {
    classMap: stc5,
    attrs: stc12,
    props: {
      "size": "small",
      "name": "headerSignup",
      "label": $cmp.labels.signup
    },
    key: 24,
    on: {
      "click": _m4 || ($ctx._m4 = api_bind($cmp.signup))
    }
  }), api_custom_element("wds-button", _wdsButton, {
    classMap: stc5,
    attrs: stc13,
    props: {
      "variant": "secondary",
      "size": "small",
      "name": "headerLogin",
      "label": $cmp.labels.login
    },
    key: 25,
    on: {
      "click": _m5 || ($ctx._m5 = api_bind($cmp.login))
    }
  })], 0)]), $cmp.showAccountLoading ? api_fragment(26, [api_element("div", stc14, [api_static_fragment($fragment5, 29, [api_static_part(1, null, api_dynamic_text($cmp.labels.accountLoading))]), api_custom_element("wds-spinner", _wdsSpinner, stc15)])], 0) : $cmp.showOrgContextMenu ? api_fragment(26, [api_element("div", stc16, [$cmp.showOrgCard ? api_fragment(32, [api_element("div", stc17, [api_element("span", stc18, [api_custom_element("ax-icon", _axIcon, {
    classMap: stc19,
    props: {
      "icon": "salesforce",
      "spriteUrl": "/images/icons.svg",
      "size": "small",
      "iconDescription": $cmp.orgIconDescription
    },
    key: 35
  }), api_static_fragment($fragment6, 37, [api_static_part(0, {
    attrs: {
      "title": $cmp.orgName
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.orgName))])]), api_static_fragment($fragment7, 39, [api_static_part(0, {
    attrs: {
      "title": $cmp.selectedOrg.username
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.selectedOrg.username))]), $cmp.hasDomain ? api_fragment(40, [api_static_fragment($fragment8, 42, [api_static_part(0, {
    attrs: {
      "title": $cmp.selectedOrg.domain
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.selectedOrg.domain))])], 0) : null, api_element("span", stc20, [$cmp.hasEdition ? api_fragment(44, [api_custom_element("ax-badge", _axBadge, {
    classMap: stc21,
    props: {
      "text": $cmp.selectedOrg.edition,
      "theme": $cmp.editionBadgeTheme
    },
    key: 45
  })], 0) : null, api_static_fragment($fragment9, 47, [api_static_part(0, {
    on: {
      "click": _m7 || ($ctx._m7 = api_bind($cmp.handleSwitchOrg))
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.switchOrgLabel))])])])], 0) : api_fragment(32, [api_static_fragment($fragment10, 49, [api_static_part(0, {
    on: {
      "click": _m9 || ($ctx._m9 = api_bind($cmp.handleSwitchOrg))
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.selectOrgLabel))])], 0)])], 0) : null, api_element("div", stc22, [$cmp.showMobileUserMenu ? api_fragment(51, [api_custom_element("ace-user-menu-mobile", _aceUserMenuMobile, stc23)], 0) : null, $cmp.showMobileHelpCenter ? api_fragment(53, [api_custom_element("ace-help-center-mobile", _aceHelpCenterMobile, stc24)], 0) : null])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-494iv6nvvdi";
tmpl.legacyStylesheetToken = "undefined-_headerV2";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
